import { authAxios as axios } from "api-generate-types/src/axios";

import { FollowUpId, IFollowUp } from "shared/models/followUp";

import config from "config/global";

class FollowUpService {
  private readonly url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public async get(
    breakdownId: string,
    followUpId: FollowUpId,
    abortController?: AbortController
  ): Promise<IFollowUp> {
    const response = await axios(
      `${this.url}/${breakdownId}/followups/${followUpId}`,
      {
        signal: abortController?.signal,
      }
    );

    return response.data;
  }
}

export default new FollowUpService({
  url: config.breakdownsApiUrl,
});
